import api from "../api/CustomerApi";
import { getCustomerToken } from "../utils/CustomerAuth";

const authHeaders = () => {
  const token = getCustomerToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Keep wishlist consistent with cart
const getActiveLocationId = () => {
  try {
    const name = localStorage.getItem("selectedLocation");
    if (!name) return null;

    const raw = localStorage.getItem("locationsList");
    if (!raw) return null;

    const list = JSON.parse(raw);
    if (!Array.isArray(list)) return null;

    const found = list.find(
      (loc) => String(loc?.name || "").toLowerCase() === name.toLowerCase()
    );

    return found?.id ? Number(found.id) : null;
  } catch {
    return null;
  }
};

export const WishlistServices = {
  getWishlist: async () => {
    const res = await api.get("/wishlist", { headers: authHeaders() });
    return res?.data?.data ?? [];
  },

  add: async ({
    product_id,
    product_info_id = null,
    location_id = null,
    location_product_price_id = null,
    product_info_location_price_id = null,
  }) => {
    const activeLocationId = location_id ?? getActiveLocationId();

    const payload = {
      product_id,
    };

    if (product_info_id != null) {
      payload.product_info_id = product_info_id;
    }

    if (activeLocationId != null) {
      payload.location_id = activeLocationId;
    }

    if (location_product_price_id != null) {
      payload.location_product_price_id = location_product_price_id;
    }

    if (product_info_location_price_id != null) {
      payload.product_info_location_price_id = product_info_location_price_id;
    }

    const res = await api.post("/wishlist/add", payload, { headers: authHeaders() });
    return res?.data;
  },

  remove: async (wishlistRowId) => {
    const res = await api.delete(`/wishlist/remove/${wishlistRowId}`, {
      headers: authHeaders(),
    });
    return res?.data;
  },

  toggle: async ({
    product_id,
    product_info_id = null,
    location_id = null,
    location_product_price_id = null,
    product_info_location_price_id = null,
  }) => {
    const activeLocationId = location_id ?? getActiveLocationId();

    const payload = {
      product_id,
    };

    if (product_info_id != null) {
      payload.product_info_id = product_info_id;
    }

    if (activeLocationId != null) {
      payload.location_id = activeLocationId;
    }

    if (location_product_price_id != null) {
      payload.location_product_price_id = location_product_price_id;
    }

    if (product_info_location_price_id != null) {
      payload.product_info_location_price_id = product_info_location_price_id;
    }

    const res = await api.post("/wishlist/toggle", payload, { headers: authHeaders() });
    return res?.data;
  },
};